import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
    selector: 'app-yes-no-dialog-box',
    templateUrl: './yes-no-dialog-box.component.html',
    styleUrls: ['./yes-no-dialog-box.component.scss']
})
export class YesNoDialogBoxComponent implements OnInit {
    @Input()
    header: string;

    @Input()
    content: string;

    @Input()
    visible: boolean;

    @Input()
    size = 'auto';

    @Input()
    confirmText: string;

    @Input()
    cancelText: string;

    @Input()
    customHeader: boolean;

    @Input()
    customContent: boolean;

    @Input()
    centerContent: boolean;

    @Input()
    withoutCloseIcon: boolean;

    @Input()
    singleBtn: boolean;

    @Input()
    wrapped: boolean;

    @Input()
    redConfirmButton: boolean;

    @Output()
    actionComplete: EventEmitter<any>;

    constructor() {
        this.actionComplete = new EventEmitter<boolean>();
    }

    ngOnInit() {
    }

    confirm() {
        this.actionComplete.emit(true);
    }

    cancel() {
        this.actionComplete.emit(false);
    }
}
